"use client"

import { useRouter, useSearchParams } from "next/navigation"
import React, { useEffect } from "react"

import SideSheet from "@modules/common/components/side-sheet"
import { sendGoogleAnalyticsEvent } from "@modules/common/utils/analytics"
import { CheckoutExperimentsDefinition } from "@modules/signup-and-order-flow/experiments/experiment-interfaces"

import { SessionProvider } from "./session-context"
import SignupAndOrderFlowSteps from "./signup-and-order-flow-steps"

interface SignupAndOrderFlowV2Props {
  treatments: CheckoutExperimentsDefinition
}

const SignupAndOrderFlowV2: React.FC<SignupAndOrderFlowV2Props> = ({ treatments }) => {
  const router = useRouter()
  const searchParams = useSearchParams()
  const isSheetOpen = searchParams.get("signup") === "1"

  useEffect(() => {
    sendGoogleAnalyticsEvent("XP_INCLUSION", {
      featureName: "mktp_checkout_flow_v2",
      trackingKey: "mktp_checkout_flow_v2_experiment",
      treatmentName: treatments.mktp_checkout_flow_v2.treatment,
    })
  }, [treatments.mktp_checkout_flow_v2.treatment])

  const handleSheetClose = () => {
    if (typeof window === "undefined") return
    const currentPath = window.location.pathname
    const currentSearch = window.location.search
    const newSearch = new URLSearchParams(currentSearch)
    newSearch.delete("signup")
    const newPath = `${currentPath}${newSearch.toString() ? `?${newSearch.toString()}` : ""}`
    router.push(newPath)
  }

  if (!isSheetOpen) {
    return null
  }

  return (
    <SideSheet isOpen={isSheetOpen} close={handleSheetClose}>
      <SessionProvider treatments={treatments}>
        <SignupAndOrderFlowSteps onCloseSheet={handleSheetClose} />
      </SessionProvider>
    </SideSheet>
  )
}

export default SignupAndOrderFlowV2
